import { WorldpayCustomisationButtons } from './worldpay-customisation-buttons.interface';
import { WorldpayCustomisationInputs } from './worldpay-customisation-inputs.interface';
import { WorldpayCustomisationPage } from './worldpay-customisation-page.interface';

export interface WorldpayCustomisation {
  backgroundColor?: string;
  buttons?: WorldpayCustomisationButtons;
  color?: string;
  fonts?: {
    family: string[];
  };
  inputs?: WorldpayCustomisationInputs;
  page?: WorldpayCustomisationPage;
}
